import { ConsoleSqlOutlined, DeleteOutlined, FilterOutlined } from '@ant-design/icons'
import { PageHeader } from '@ant-design/pro-layout'
import { CONSTANT } from '@salescore/client-base'
import { canViewDimensionFilter, useMe } from '@salescore/client-common'
import { App, Button, List, type ModalFuncProps, Space } from 'antd'
import { t } from 'i18next'
import { useRecoilState } from 'recoil'

import { kpiParameterAtom } from '../../../../recoil/navigation/atoms'
import { buildViewDebugModalProperties } from '../../ViewUISheetWithNavigation/ViewDebugModal'

export const buildDimensionFiltersModal = (): ModalFuncProps => ({
  icon: null,
  title: null,
  width: '90%',
  style: {
    maxWidth: 1000,
  },
  content: <ModalContent />,
  okButtonProps: { style: { display: 'none' } },
  cancelButtonProps: { style: { display: 'none' } },
  closable: true,
  maskClosable: true,
  destroyOnClose: true,
})

function ModalContent() {
  const { modal } = App.useApp()
  const me = useMe()
  const [parameter, setParameter] = useRecoilState(kpiParameterAtom)
  const filters = parameter.dimensionFilterLeafs ?? []

  return (
    <PageHeader
      title={
        <Space>
          <FilterOutlined />
          <span>
            {t(`絞り込み`)}({t(`ダッシュボード`)})
          </span>
        </Space>
      }
      extra={[
        canViewDimensionFilter(me) && (
          // eslint-disable-next-line @eslint-react/no-missing-key
          <Button
            type="text"
            className={CONSTANT.colorClasses.ADMIN_TEXT_COLOR}
            style={{ width: '100%', textAlign: 'left' }}
            icon={<ConsoleSqlOutlined />}
            onClick={() => {
              const m = modal.confirm(
                buildViewDebugModalProperties({
                  content: filters,
                  onAfterFinish: () => {
                    m.destroy()
                  },
                }),
              )
            }}
          >
            {t(`スキーマ表示`)}
          </Button>
        ),
      ]}
    >
      <List
        bordered
        itemLayout="horizontal"
        dataSource={filters}
        renderItem={(filter, index) => {
          if (filter.type !== 'dimension') {
            return <></>
          }

          return (
            <List.Item
              actions={[
                <Space
                  key="delete"
                  className="cursor-pointer text-blue-500"
                  onClick={() => {
                    setParameter((x) => ({
                      ...x,
                      dimensionFilterLeafs: [
                        ...(x.dimensionFilterLeafs?.slice(0, index) ?? []),
                        ...(x.dimensionFilterLeafs?.slice(index + 1) ?? []),
                      ],
                    }))
                  }}
                >
                  <DeleteOutlined /> {t(`削除`)}
                </Space>,
              ]}
            >
              {t(`{{label}} が {{valueLabel}} に等しい`, {
                label: filter.dimension.label,
                valueLabel: filter.filterValueLabel,
              })}
            </List.Item>
          )
        }}
      />
    </PageHeader>
  )
}
